import { styles } from '@app/services/app-styles.service';

const checkbox = {
    root: {
        borderRadius: styles().borderRadiusCheckbox,
    },
    icon: {
        size: '0.8rem',
    },
};

export default checkbox;
